'use client';

import { useToast } from '../hooks/useToaster';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './Toast';
import { Flex } from './layout';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <Flex direction='col' gap='sm' className='w-full min-w-0 flex-1'>
              <Flex direction='col' gap='xs' className='min-w-0 w-full'>
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </Flex>
              {action && (
                <Flex align='center' gap='sm'>
                  {action}
                </Flex>
              )}
            </Flex>
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
